import type { PlanStrategyType } from '../types';
import type { PlanStrategy } from './type';

const cache = new Map<PlanStrategyType, PlanStrategy>();
const pending = new Map<PlanStrategyType, Promise<PlanStrategy>>();

const loaders: Record<PlanStrategyType, () => Promise<{ default: PlanStrategy }>> = {
  NAIVE: () => import('./naive'),
  RTB: () => import('./rtb'),
  OOH: () => import('./ooh'),
  RADIO: () => import('./radio'),
  PRESS: () => import('./press'),
};

export function getStrategy(key: PlanStrategyType): PlanStrategy | Promise<PlanStrategy> {
  const cached = cache.get(key);
  if (cached) return cached;

  let promise = pending.get(key);
  if (!promise) {
    promise = loaders[key]()
      .then((mod) => {
        cache.set(key, mod.default);
        return mod.default;
      })
      .finally(() => pending.delete(key));
    pending.set(key, promise);
  }
  return promise;
}
